import React, {

  useEffect,
  useMemo,
  useState,
  
} from "react";
import { useNavigate } from "react-router-dom";
import "../styles/testconsole.css";

const LeftTestConsole = ({
  setQues,
  ansArray,
  catName,
  quesData,
  type,
  testId,
  curQues,
  visitedArr,
  MyTimer,
  time,
  timeExpired,
  rankArray,
  onSubmitClick,
}) => {
  //const navigate = useNavigate();
  //const [showConfirm, setShowConfirm] = useState(false);

console.log("LeftTestConsole", onSubmitClick);

  const total = quesData.length;
  const answered = useMemo(
    () => ansArray.filter((ans) => ans !== undefined && ans !== null).length,
    [ansArray]
  );

  const visited = useMemo(
    () => visitedArr.filter((x) => x !== undefined).length + (typeof visitedArr[curQues] === "number" ? 0 : 1),
    [visitedArr, curQues]
  );

  const notVisited = Math.max(total - (visitedArr.filter((x) => x !== undefined).length + 1), 0);
  const notAnswered = Math.max(visited - answered, 0);

  const arr = Array.from({ length: total }, (_, i) => i);

 /*  const submitTest = () => {
    navigate(`/online-practice-test-result/${catName.replaceAll(" ", "-")}`, {
      state: {
        ansArray,
        catName,
        quesData,
        type,
        testId,
        rankArray,
      },
    });
  }; */

/*   useImperativeHandle(ref, () => ({
    submitExam: () => {
        setShowConfirm(true);
    }
})); */

  /* useEffect(() => {
    if (timeExpired !== 0) submitTest();
  }, [timeExpired]); 
 */
  return (
    <>
      <div className="lc-summary">
        <ul className="lc-summary-list">
          <li>
            <button className="badge answered">{answered}</button>
            <span className="badge-label">Answered</span>
          </li>
          <li>
            <button className="badge not-answered">{notAnswered}</button>
            <span className="badge-label">Not Answered</span>
          </li>
          <li>
            <button className="badge not-visited">{notVisited}</button>
            <span className="badge-label">Not Visited</span>
          </li>
        </ul>
      </div>

      <div className="lc-grid">
        {arr.map((item) => {
          const isCurrent = curQues === item;
          const hasAns = !!ansArray[item];
          const wasVisited = visitedArr[item] === item;
          let cls = "num";
          if (isCurrent) cls += " current";
          else if (hasAns) cls += " answered";
          else if (wasVisited) cls += " visited";
          return (
            <button key={item} className={`lc-num ${cls}`} onClick={() => setQues(item)}>
              {item + 1}
            </button>
          );
        })}
      </div>

     <div className="lc-submit">
 <button
    className="danger-btn"
    onClick={() => {
        console.log("Desktop button clicked");
        onSubmitClick();
    }}
>
    Submit Test
</button>
</div>

      

    </>
  );
};

export default LeftTestConsole;
